import { useEffect, useState, useCallback, useContext } from "react";
import { useSnackbar } from "notistack";
import { Grid } from "@mui/material";
import { useStyles } from "./styles";
import SummaryCard from "../../components/SummaryCard/SummaryCard";
import AllScansTable from "../../components/InvoiceTable/AllScansTable";
import httpRequest from "../../httpRequest";
import AppLayout from "../../components/AppLayout/AppLayout";
import UserContext from "../../context/user-context"; // Import UserContext


const HistoryPage = () => {
  const classes = useStyles();
  const [selectedInvoice, setSelectedInvoice] = useState({});
  const [invoicesData, setInvoicesData] = useState([]);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  // Access the UserContext
  const userCtx = useContext(UserContext);
  const { overriddenRole, employeeData, userId } = userCtx; // Extract relevant data from context


  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [invoicesResp] = await Promise.all([
        httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-invoices?exclude_fields=pdf_file,image_file`),
      ]);

      setInvoicesData(invoicesResp.data.invoices);
    } catch (error) {
      console.error("Error fetching data:", error);
      enqueueSnackbar("Error fetching data", { variant: "error" });
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  const handleBackButtonClick = () => {
    setIsSummaryOpen(false);
    fetchData();
  };

  const openSummary = (invoiceData) => {
    setIsSummaryOpen(true);
    setSelectedInvoice(invoiceData);
  };

  const handleDataChange = () => {
    fetchData();
  };

  // Filter invoices based on user permissions and companies and functions
  const filteredInvoices = invoicesData.filter((invoice) => {
    if (overriddenRole.can_access_all_scans) {
      return true;
    }

    if (overriddenRole.can_access_all_company_scans) {
      return employeeData.companies.some(company => company.id === invoice.company_id);
    }

    // Check if the invoice belongs to any of the user's companies
    const isCompanyMatch = employeeData?.companies.some(company => company.id === invoice.company_id);

    // Check if the invoice's function_id matches the user's function_id
    const isFunctionMatch = employeeData?.functions.some(func => func.id === invoice.function_id);

    // Return true if the user has access to the company and function for this invoice
    return isCompanyMatch && isFunctionMatch;
  });

  // useEffect to fetch data on mount
  useEffect(() => {
    fetchData();
  }, [fetchData]); // fetchData is stable because of useCallback

  return (
    <AppLayout>
      <Grid container>
        {!isSummaryOpen && (
          <div className={classes.table}>
            <AllScansTable
              invoiceData={filteredInvoices}
              openSummary={openSummary}
              refreshInvoiceData={fetchData} // Pass fetchData to refresh invoices
              loading={loading}
            />
          </div>
        )}
      </Grid>
      {isSummaryOpen && (
        <div>
          <SummaryCard
            dataFromDB={selectedInvoice}
            dataChanged={handleDataChange}
            onBackButtonClick={handleBackButtonClick}
          />
        </div>
      )}
    </AppLayout>
  );
};

export default HistoryPage;
